var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExternalLink = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m9.6 4-.001 1.5H6a.5.5 0 0 0-.492.41L5.5 6v8a.5.5 0 0 0 .41.492L6 14.5h8a.5.5 0 0 0 .492-.41L14.5 14v-3.6H16V4.983 15a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.566 4H16v4.434a.4.4 0 0 1-.683.283l-4.034-4.034A.4.4 0 0 1 11.566 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.869 4 16 5.131l-5.374 5.374a.4.4 0 0 1-.566 0l-.565-.565a.4.4 0 0 1 0-.566z"
  }))));
};
export default SvgExternalLink;